import { ref } from "vue"
import Tr from "@/translations"

/**
 * Parrilla de subcategorias de la landing del catalogo. La categoria que se
 * muestra la decide el backend por configuracion (catalogue.grid_category_code).
 *
 * Mismas dos diferencias que getCategoriesAndSubcategories: URL construida
 * dentro de load() e isLoading gestionado aqui.
 */
const getCategoriesGridArticles = () => {

    const items = ref([])
    const error = ref(null)
    const isLoading = ref(false)

    const load = async () => {
        isLoading.value = true
        error.value = null

        try {
            const response = await fetch(process.env.VUE_APP_ROOT_API + "articles/categories-grid/" + Tr.currentLocale)
            const data = await response.json()

            if (data.error || Number(data.code) !== 200) {
                items.value = []
                error.value = { code: Number(data.code) || response.status, message: data.message }
                return
            }

            items.value = data.results || []
        } catch (err) {
            items.value = []
            // code 0 = no hubo respuesta del servidor
            error.value = { code: 0, message: err.message }
        } finally {
            isLoading.value = false
        }
    }

    return { items, error, isLoading, load }
}

export default getCategoriesGridArticles
